<template>
  <footer class="footer bg_footer  ">
    <div class="bc">
      <div class="row main_row">
        <div class="col-auto logo_area ">
          <a class="navbar-brand mr-0 mr-md-2" href="/">
            <img class="logo" src="/img/image/common/logo.png" loading="lazy" alt="滿香脆"/>
          </a>
          <div class="d-xl-block d-none icon_area">
            <div class="row no-gutters px-2 py-5 justify-content-xl-start justify-content-lg-center">

              <a class="col-auto icon" :href="instagramUrl" target="_blank" data-toggle="tooltip" title="Instagram"
                 v-if="hasSetting">
                <img class="icon" src="/img/image/icon/ig_logo.png" loading="lazy" alt="instagram"/>
              </a>
              <div class="span-24"/>
              <a class="col-auto icon" :href="lineUrl" target="_blank" data-toggle="tooltip" title="Line"
                 v-if="hasSetting">
                <img class="icon" src="/img/image/icon/line_loge.png" loading="lazy" alt="Line" />
              </a>
              <div class="w-auto span-24"/>
              <a class="col-auto icon" :href="facebookUrl" target="_blank" data-toggle="tooltip" title="Facebook"
                 v-if="hasSetting">
                <img class="icon" src="/img/image/icon/fb_loge.png" loading="lazy" alt="Facebook"/>
              </a>
            </div>
          </div>
        </div>


        <div class="col-auto">
          <div class="row no-gutters item_area">
            <div class="group_area">
              <div class="title text-white text-center">認識滿香脆</div>
              <hr class="hr">
              <div class="text-center">
                <a class="text-white item_link"  href="/#story" v-on:click='clickAnchor("story")'
                   rel="nofollow" alt="品牌故事">品牌故事</a>
              </div>
              <div class="pb-3"/>
              <div class="text-center">
                <a class="text-white item_link"  href="/#follow" v-on:click='clickAnchor("follow")'
                   rel="nofollow" alt="最新消息">最新消息</a>
              </div>
            </div>
            <div class="group_area_space"/>
            <div class="group_area">
              <div class="title text-white text-center">加盟服務</div>
              <hr class="hr">
              <div class="text-center">
                <a class="text-white item_link"  href="/#advantage" v-on:click='clickAnchor("advantage")'
                   rel="nofollow" alt="加盟優勢">加盟優勢</a>
              </div>
              <div class="pb-3"/>
              <div class="text-center">
                <a class="text-white item_link"  href="/join" v-on:click='clickAnchor("join")'
                   rel="nofollow" alt="我要加盟">我要加盟</a>
              </div>
            </div>
            <div class="group_area_space_center"/>
            <div class="group_area">
              <div class="title text-white text-center">美味專區</div>
              <hr class="hr">
              <div class="text-center">
                <a class="text-white item_link"  href="/#feature" v-on:click='clickAnchor("feature")'
                   rel="nofollow" alt="產品特色">產品特色</a>
              </div>
              <div class="pb-3"/>
              <div class="text-center">
                <a class="text-white item_link"  href="/#taste_now" v-on:click='clickAnchor("taste_now")'
                   rel="nofollow" alt="立即品嚐">立即品嚐</a>
              </div>
              <div class="pb-3"/>
              <div class="text-center">
                <a class="text-white item_link"  href="/#how_to_eat" v-on:click='clickAnchor("how_to_eat")'
                   rel="nofollow" alt="食用方法">食用方法</a>
              </div>
              <div class="pb-3"/>
              <div class="text-center">
                <a class="text-white item_link"  href="/#store" v-on:click='clickAnchor("store")'
                   rel="nofollow" alt="分店資訊">分店資訊</a>
              </div>
            </div>
            <div class="group_area_space"/>
            <div class="group_area">
              <div class="title text-white text-center">FAQ</div>
              <hr class="hr">
              <div class="text-center">
                <a class="text-white item_link" href="/#faq" rel="nofollow" alt="常見問題">常見問題</a>
              </div>
              <div class="pb-3"/>
<!--              <div class="text-center">-->
<!--                <a class="text-white item_link" href="javascript:void(0)" v-on:click='clickAnchor("")'-->
<!--                   rel="nofollow" alt="隱私政策">隱私政策</a>-->
<!--              </div>-->
<!--              <div class="pb-3"/>-->
<!--              <div class="text-center">-->
<!--                <a class="text-white item_link" href="javascript:void(0)" v-on:click='clickAnchor("")'-->
<!--                   rel="nofollow" alt="使用者條款">使用者條款</a>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
      <div style="height: 90px;"/>
      <div class="row no-gutters justify-content-center copyright text-white text-center">
        <div class="d-lg-block d-none">
          Copyright &copy; {{ year }} FullCrispy All Rights Reserved.
        </div>

        <div class="d-block d-lg-none  col-sm-12 pb-1 ">
          Copyright &copy;
        </div>

        <div class="d-block d-lg-none col-sm-12 ">
          {{ year }} FullCrispy All Rights Reserved.
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import {isEmpty} from "@/util/helpers";

export default {
  name: 'app-footer',
  data() {
    return {
      year: '2024',
    }
  },
  computed: {
    hasSetting() {
      return !!this.settingData;
    },
    settingData() {
      return this.$store.getters.getSettingData;
    },
    instagramUrl() {
      let val = this.settingData.data.url_instagram;
      return isEmpty(val) ? '' : val;
    },
    lineUrl() {
      let val = this.settingData.data.url_line;
      return isEmpty(val) ? '' : val;
    },
    facebookUrl() {
      let val = this.settingData.data.url_facebook;
      return isEmpty(val) ? '' : val;
    },
  },
  methods: {
    clickAnchor(target) {
      // if (isEmpty(target)) return;
      // const element = document.getElementById(target);
      // if (target === "join") {
      //   this.$router.push({path: '/join'});
      // } else if (this.$route.path === '/') {
      //   element.scrollIntoView({behavior: 'smooth'});
      // } else {
        this.$router.push({path: '/', hash: target},);
      // }
    }
  },
};
</script>
<style lang="scss" scoped>


@media (max-width: 425px) {
  .footer {
    padding-left: 30px;
    padding-right: 30px;
  }
}

.bg_footer {
  background-image: url('/img/image/background/bg_s3.png');
  background-size: cover; /* 确保背景图像覆盖整个元素 */
  background-position: center; /* 将图像居中 */
  background-repeat: no-repeat; /* 防止图像重复 */
}

.bc {
  margin: 0 auto;
  height: auto;
  max-width: 1440px;
}


.logo {
  height: 40px; /* 设置高度为 100 像素 */
  width: auto; /* 根据高度自动调整宽度，保持比例 */
}

.span-24 {
  min-width: 24px;
}

.span-16 {
  width: 16px;
  height: 16px;
}


.main_row {
  justify-content: space-between;
}

@media (max-width: 1280px) {
  .main_row {
    flex-direction: column;
    align-items: center;
  }
}

.logo_area {

}


@media (max-width: 1280px) {
  .logo_area {
    margin-bottom: 50px;
  }
}

.icon_area {

}

@media (max-width: 1280px) {
  .icon_area {
    height: 0;
    width: 0;
    visibility: hidden;
    flex: 0;
    padding: 0;
    margin: 0;
  }
}


.item_area {

}

@media (max-width: 1030px) {
  .item_area {
    justify-content: center;
  }
}

.group_area {
  max-width: 180px;
  width: 180px;
}

@media (max-width: 1030px) {
  .group_area {
    width: 40%;
    flex: 0 0 40%;
    max-width: 40%;
    min-width: 100px;
    margin-bottom: 60px;
  }
}


.group_area_space {
  width: 50px;
}

.group_area_space_center {
  width: 50px;
}

@media (max-width: 1030px) {
  .group_area_space_center {
    width: 0px;
  }
}


.title {
  font-size: 1rem;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-align: left;
}

.hr {
  height: 1px; /* 设置 hr 的高度 */
  background-color: #D56835; /* 设置 hr 的背景颜色 */
  border: none; /* 移除 hr 默认的边框 */
}

.item_link {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
}


</style>
